

















































import { Vue, Component, Prop } from 'vue-property-decorator';
import CardBasic from '@/shared/card/card-basic.component.vue';
import ReasonsCancellation from '@/domain/justify/domain/reasons-cancellation.entity';
import ReasonsCancellationService from '@/domain/justify/service/reasons-cancellation.service';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import ModalOptions from '@/shared/modal/modal-options.entity';

@Component({
  components: {
    CardBasic,
    ModalWarning,
  },
})
export default class ReasonsCancellationDatatable extends Vue {
  @Prop({ required: true, default: '' }) private businessUnitId!: string;

  listReasons: ReasonsCancellation[] = [];

  loading: boolean = false;

  reasonCancellationIdToDelete: string | null = null;

  warningModal: boolean = false;

  warningMessage = 'Deseja realmente prosseguir? Ao clicar no botão Sim, '
    + 'o motivo de cancelamento será removido.';

  created() {
    this.loadReasons();
  }

  get options(): ModalOptions {
    return {
      title: 'Excluir Motivo de Cancelamento',
      titleAlign: 'center',
      showClose: false,
      showOk: true,
      labelOk: 'Excluir',
      okColor: 'redPrimary',
      showCancel: true,
      labelCancel: 'Cancelar',
      width: 720,
      persistent: true,
    }
  }

  closeWarningModal() {
    this.warningModal = false;
    this.reasonCancellationIdToDelete = null;
  }

  handleConfirm() {
    if (this.reasonCancellationIdToDelete) {
      this.inactiveReason(this.reasonCancellationIdToDelete);
    }
    this.closeWarningModal();
  }

  validateDelete(reasonCancellationId: string) {
    this.reasonCancellationIdToDelete = reasonCancellationId;
    this.warningModal = true;
  }

  loadReasons() {
    if (this.loading) return;
    this.loading = true;
    ReasonsCancellationService.getAll(this.businessUnitId)
      .then((response: ReasonsCancellation[]) => {
        this.listReasons = response;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  inactiveReason(reasonCancellationId: string) {
    ReasonsCancellationService.inactiveReasonsCancellation(
      reasonCancellationId,
    )
      .finally(() => {
        this.$emit('reload-list');
      });
  }

  editReasonCancellation(reasonCancellationId: string) {
    this.$emit('edit-reason-cancellation', reasonCancellationId);
  }
}
